<template>
  <el-col :span="props.spanColumn">
    <div
      v-if="!props.settings.hideLabel"
      class="label"
    >
      {{ props.label ? props.label : '\u00A0' }}
      <el-tooltip
        v-if="props.settings.tooltip"
        :content="props.settings.tooltip"
        :trigger="['hover', 'click']"
        placement="top"
        popper-class="custom-select-tooltip"
      >
        <IconInformationOutline class="info-icon" />
      </el-tooltip>
    </div>
    <el-select
      v-model="value"
      :multiple="props.settings.multiple"
      :filterable="props.settings.filterable"
      :clearable="props.settings.clearable"
      :collapse-tags="props.settings.multiple"
      :placeholder="props.settings.placeholder || 'Seleccionar opción'"
      :class="props.settings.inputClass"
      :size="settings.size || 'default'"
      :disabled="props.settings.disabled"
      :value-key="props.fieldKey"
      :loading="props.loading"
      @clear="handleClear"
    >
      <el-option
        v-for="option in props.settings.options"
        :key="option[props.fieldKey]"
        :label="option[props.fieldLabel]"
        :value="option"
        :disabled="!!option.disabled"
      ></el-option>
    </el-select>
  </el-col>
</template>

<script setup>
import { computed } from 'vue';
import IconInformationOutline from '~icons/mdi/information-outline';

// Props
const props = defineProps({
  spanColumn: Number,
  label: String,
  settings: {
    multiple: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'default',
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    placeholder: String,
    inputClass: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    key: {
      type: String,
      default: 'Codigo',
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    /** Texto del tooltip; si se pasa, muestra el ícono de información junto al label. */
    tooltip: String,
  },
  modelValue: {
    type: [String, Number, Boolean, Object, Array],
  },
  storeObject: {
    type: Boolean,
    default: true, // Esta prop determina si se almacena el objeto completo o solo su valor
  },
  fieldKey: {
    type: String,
    default: 'Codigo',
  },
  fieldLabel: {
    type: String,
    default: 'Descripcion',
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue', 'click:clearable']);

const value = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit('update:modelValue', props.storeObject ? newValue : newValue[props.fieldLabel]);
  },
});

const handleClear = () => {
  emit('click:clearable');
};
</script>

<style scoped>
.label {
  font-weight: 700;
  color: #111;
}
.ancho_total {
  width: 100%;
}
.custom-select {
  width: 100%;
}

.info-icon {
  margin-left: 4px;
  vertical-align: middle;
  color: #909399;
  cursor: pointer;
}
</style>

<style>
/* El contenido del tooltip se teletransporta fuera del componente (Element Plus lo
   monta en <body>), así que no lo alcanza el <style scoped> de arriba. */
.custom-select-tooltip {
  max-width: 260px;
  font-size: 12px;
  line-height: 1.5;
  white-space: normal;
}
</style>
